import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelGEA as t } from "../level-metrics/index19.js";
const A = (e) => r(e, t);
export {
  A as getLevelArrayGEA
};
//# sourceMappingURL=index8.js.map
